import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "titlebar-title --mobile" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "titlebar-text" }, "Categorias")
  ])
], -1)
const _hoisted_4 = { class: "titlebar-actions" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_6 = { class: "titlebar-actions-primary" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Nova categoria")
], -1)
const _hoisted_8 = { class: "ui-card" }
const _hoisted_9 = { class: "ui-card-body" }
const _hoisted_10 = { class: "ant-row ui-mb-20" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_12 = { class: "ant-input-affix-wrapper" }
const _hoisted_13 = { class: "ant-input-prefix" }
const _hoisted_14 = {
  role: "img",
  "aria-label": "user",
  type: "user",
  class: "anticon anticon-user"
}
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-input-group-wrapper" }
const _hoisted_17 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon ui-fw-500" }, "Ordenar", -1)
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_20 = { class: "ui-table" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-16 ui-cell" }, " Nome "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell" }, " Status "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-align-center" }, " Ações ")
], -1)
const _hoisted_22 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_23 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-16 ui-cell ui-ellipsis",
  "data-title": "Nome"
}
const _hoisted_24 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-ellipsis",
  "data-title": "Status"
}
const _hoisted_25 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-align-center",
  "data-title": "Ações"
}
const _hoisted_26 = { class: "ui-actions" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, " Aplicar ", -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, null, -1)
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_affix = _resolveComponent("a-affix")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_affix, { "offset-top": 50 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                class: "ui-button -primary",
                to: { name: 'CategoriaCadastroCriar' }
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_icone, { nome: "pesquisar" })
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Buscar por Nome",
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.parametrosConsulta.valorPesquisa) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buscarCategoriaPorNome()))
              }, null, 544), [
                [_vModelText, _ctx.state.parametrosConsulta.valorPesquisa]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_a_select, {
                  class: "ui-full",
                  value: _ctx.state.ordenarPor,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.ordenarPor) = $event)),
                  "show-search": "",
                  placeholder: "Ordenar por",
                  options: _ctx.state.opcoesOrdenacao,
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscarDados()))
                }, null, 8, ["value", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              class: "ui-button -second ui-mh-32 ui-full",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.apresentarFiltros =!_ctx.state.apresentarFiltros))
            }, [
              _createVNode(_component_icone, {
                class: "ui-mr-5",
                nome: "filtro"
              }),
              _createTextVNode(" Filtros ")
            ])
          ])
        ]),
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            ((_ctx.state.categorias.length > 0))
              ? (_openBlock(), _createBlock(_component_a_form, {
                  key: 0,
                  layout: "vertical"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.categorias, (Categoria) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: Categoria.codigo,
                            class: "ant-row ui-row"
                          }, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_router_link, {
                                title: Categoria.nome,
                                class: "ui-link",
                                to: { name: 'CategoriaCadastroEditar', params: { codigo:Categoria.codigo }}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(Categoria.nome), 1)
                                ]),
                                _: 2
                              }, 1032, ["title", "to"])
                            ]),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(Categoria.status === true?'Ativa':'Inativa'), 1),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_a_tooltip, { title: "Editar categoria" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, {
                                      class: "ui-action",
                                      to: { name: 'CategoriaCadastroEditar', params: { codigo:Categoria.codigo }}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icone, { nome: "editar" })
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_a_tooltip, { title: "Deletar categoria" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("a", {
                                      class: "ui-action",
                                      onClick: ($event: any) => (_ctx.confirmaExclusao(Categoria))
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_27)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_a_pagination, {
                          class: "ui-pagination",
                          current: _ctx.appBase.paginacao.paginaAtual,
                          "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.appBase.paginacao.paginaAtual) = $event)),
                          size: "small",
                          total: _ctx.appBase.paginacao.totalRegistros,
                          "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} categorias`,
                          "page-size": _ctx.appBase.paginacao.qtdeRegistrosPagina,
                          "show-size-changer": "",
                          onShowSizeChange: _ctx.qtdeRegistrosPaginaAlterada,
                          onChange: _ctx.paginacaAlterada
                        }, null, 8, ["current", "total", "show-total", "page-size", "onShowSizeChange", "onChange"])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_result, {
                  key: 1,
                  status: "404",
                  title: "Nenhuma categoria encontrada",
                  "sub-title": "Verifique os seus filtros ou efetue um novo cadastro."
                }))
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createVNode(_component_a_drawer, {
      visible: _ctx.state.apresentarFiltros,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.apresentarFiltros) = $event)),
      class: "custom-class",
      style: {"color":"red"},
      title: "Filtros",
      placement: "right"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              class: "ui-button -primary ui-full",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.buscarDados()))
            }, _hoisted_33)
          ]),
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              class: "ui-button -second ui-full",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.limparFiltros()))
            }, " Limpar filtros ")
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_collapse, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse_panel, {
              key: "1",
              header: "Status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  class: "ui-inline-grid",
                  value: _ctx.state.parametrosConsulta.status,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.parametrosConsulta.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: true }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ativa")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: false }, {
                      default: _withCtx(() => [
                        _createTextVNode("Inativa")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: undefined }, {
                      default: _withCtx(() => [
                        _createTextVNode("Todas")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}